<div class="one-row">
    <h1 mat-dialog-title>Hilfe</h1>
    <span class="spacer"></span>
    <button *kienePermission="[10032]" mat-stroked-button color="accent" (click)="openTicketDialog()">
        <mat-icon>support_agent</mat-icon>
        VETVET kontaktieren
    </button>

    <span class="spacer"></span>
    <div *kienePermission="[402]">
        <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="createHilfereiter()">
                <mat-icon color="accent">add</mat-icon>
                Neuer Hilfe
            </button>
            <button mat-menu-item (click)="updateHilfereiter()" *kienePermission="[402]">
                <mat-icon>edit</mat-icon>
                Hilfe bearbeiten
            </button>
        </mat-menu>
    </div>
</div>
<mat-dialog-content class="dialog-content">
    <div *ngIf="hilfe.hilfe_reiter.length === 0">
        <p>Es sind noch keine Hilfeseiten vorhanden.</p>
    </div>
    <mat-tab-group #matTabGroup (selectedTabChange)="onTabChange($event)" *ngIf="hilfe?.hilfe_reiter?.length">
        <mat-tab [label]="reiter.titel || 'Neue Hilfe'" *ngFor="let reiter of hilfe.hilfe_reiter; let i = index">
            <ng-template mat-tab-label>
                <span>{{ reiter.titel || "Neue Hilfe" }}</span>

                <!--                        <button mat-icon-button (click)="removeTab(i)" *kienePermission="[402]">-->
                <!--                            <mat-icon>close</mat-icon>-->
                <!--                        </button>-->
            </ng-template>

            <!--                    <form [formGroup]="getFormGroup(i)" *kienePermission="[402]">-->

            <!--                        <div class="one-row" style="margin-top: 24px;">-->
            <!--                            <mat-form-field style="width: 48%">-->
            <!--                                <mat-label>Titel</mat-label>-->
            <!--                                <input type="text" matInput formControlName="titel" (change)="setTitel(reiter, $event)">-->
            <!--                            </mat-form-field>-->

            <!--                            <span class="spacer"></span>-->

            <!--                            <mat-form-field style="width: 48%">-->
            <!--                                <mat-label>Hilfe für Benutzerrollen freigeben</mat-label>-->
            <!--                                <mat-select multiple formControlName="benutzerrollen"-->
            <!--                                            (selectionChange)="setRollen(reiter, $event)" [compareWith]="compareRoles">-->
            <!--                                    <mat-option *ngFor="let r of roles" [value]="r">-->
            <!--                                        {{ r.bezeichnung }}-->
            <!--                                    </mat-option>-->
            <!--                                </mat-select>-->
            <!--                                <mat-error *ngIf="getFormGroup(i).get('benutzerrollen')?.hasError('minLength')">-->
            <!--                                    Bitte mindestens eine Rolle auswählen.-->
            <!--                                </mat-error>-->
            <!--                            </mat-form-field>-->
            <!--                        </div>-->

            <!--                        <div class="one-row" *kienePermission="[402]">-->
            <!--                            <mat-form-field style="width: 85%">-->
            <!--                                <mat-label>Hilfeseite - URL</mat-label>-->
            <!--                                <input type="text" matInput formControlName="hilfeseite_url">-->
            <!--                            </mat-form-field>-->
            <!--                            <span class="spacer"></span>-->
            <!--                            <button mat-button [disabled]="!getFormGroup(i).valid" (click)="setUrl(i)" color="accent">-->
            <!--                                URL übernehmen-->
            <!--                            </button>-->
            <!--                        </div>-->

            <!--                    </form>-->

            <div *ngIf="loading && reiter.showIframe && data.hilfe.projekt === 'desktop'" class="spinner-container">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>

            <div style="width: 100%; height: calc(100vh - 280px); overflow-y: hidden" *ngIf="reiter.showIframe">
                <iframe
                    #iframeRef
                    [src]="reiter?.sichereUrl"
                    allowfullscreen
                    style="width: calc(100% - 12px); height: 100%"
                ></iframe>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Schlie&szlig;en</button>
    <button (click)="save()" color="accent" mat-flat-button *kienePermission="[402]" [disabled]="isDisabled()">
        Speichern
    </button>
</mat-dialog-actions>
